<template>
  <div class="ma-4">
    <v-row>
      <v-col cols="12" md="10" offset-md="1" lg="8" offset-lg="2">
        <v-card>
          <v-card-title>Scots Portal 2.0</v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col v-for="(col, index) in cols" :key="'col-' + index" :cols="12 / cols.length">
        <component v-for="widget in col" :key="widget" v-bind:is="widget" class="mb-2" />
      </v-col>
      <!-- <v-col v-for="comp in components" :key="comp" cols="12" md="6" :lg="components.length === 4 ? '6' : '4'" xl="3">
        <component v-bind:is="comp" class="mb-2"></component>
      </v-col> -->
      <!-- <template v-if="breakpoint === 'xs'">
        <v-col cols="12">
          <banner-links></banner-links>
        </v-col>
        <v-col cols="12">
          <student-links></student-links>
        </v-col>
        <v-col cols="12">
          <helpful-links class="mb-2"></helpful-links>
        </v-col>
        <v-col cols="12">
          <workstudy-widget mini></workstudy-widget>
        </v-col>
      </template>
      <template v-else-if="breakpoint === 'sm'">
        <v-col cols="6">
          <banner-links class="mb-2"></banner-links>
        </v-col>
        <v-col cols="6">
          <student-links></student-links>
        </v-col>
        <v-col cols="12">
          <helpful-links class="mb-2"></helpful-links>
        </v-col>
        <v-col cols="12">
          <workstudy-widget mini></workstudy-widget>
        </v-col>
      </template>
      <template v-else-if="breakpoint === 'md'">
        <v-col cols="6">
          <banner-links class="mb-2"></banner-links>
          <helpful-links class="mb-2"></helpful-links>
        </v-col>
        <v-col cols="6">
          <student-links class="mb-2"></student-links>
          <workstudy-widget mini class="mb-2"></workstudy-widget>
        </v-col>
      </template>
      <template v-else-if="breakpoint === 'lg' || breakpoint === 'xl'">
        <v-col cols="4">
          <banner-links class="mb-2"></banner-links>
        </v-col>
        <v-col cols="4">
          <student-links class="mb-2"></student-links>
        </v-col>
        <v-col cols="4">
          <workstudy-widget mini class="mb-2"></workstudy-widget>
        </v-col>
      </template> -->
    </v-row>
  </div>
</template>

<script>
import { ref, computed, onMounted } from '@vue/composition-api'
import { inArray } from '@/helpers/functions'

export default {
  components: {
    BannerLinks: () => import('@/components/dashboard/Banner'),
    StudentLinks: () => import('@/components/dashboard/Student'),
    WorkstudyWidget: () => import('@/components/work-study/widget'),
    HelpfulLinks: () => import('@/components/dashboard/HelpfulLinks'),
    ServeWidget: () => import('@/components/dashboard/Serve'),
    MusicWidget: () => import('@/components/student/music/widget'),
    ChapelWidget: () => import('@/components/dashboard/Chapel')
  },
  setup (props, { root, store }) {
    const user = computed(() => root.$store.state.user.spoof || root.$store.state.user)
    const isStudent = computed(() => {
      return inArray('Students', user.value.roles)
    })
    const hasServe = ref(false)
    const isMusicStudent = ref(false)

    const breakpoint = computed(() => root.$vuetify.breakpoint.name)

    const placements = ref([])
    onMounted(async () => {
      let pidm = user.value.pidm
      // if (pidm === '2552') pidm = '1248667'
      placements.value = await root.$store.dispatch('work-study/loadPlacements', { pidm })
      if (isStudent.value) {
        root.$feathers.service('serve/student').find({ query: { pidm: user.value.pidm, $limit: 0 } }).then(({ total }) => {
          if (total > 0) hasServe.value = true
        })

        const dt = new Date()
        let term = dt.getFullYear() + '' + (dt.getMonth() < 5 ? '05' : (dt.getMonth() >= 7 ? '60' : ''))
        root.$feathers.service('calendar/classes').find({ query: { term, title: { $regex: '^MUS[1-4]0[1-9]' }, 'students.pidm': user.value.pidm } }).then(({ total }) => {
          if (total > 0) isMusicStudent.value = true
        })
      }
    })

    const cols = computed(() => {
      const components = ['BannerLinks', 'StudentLinks']
      if (placements.value.length > 0) components.push('WorkstudyWidget')
      if (hasServe.value) components.push('ServeWidget')
      if (isStudent.value) components.push('ChapelWidget')
      if (isMusicStudent.value) components.push('MusicWidget')
      components.push('HelpfulLinks')

      const columns = []
      const size = { xl: 4, lg: 3, md: 2, sm: 1, xs: 1 }
      for (let i = 0; i < size[breakpoint.value]; i++) columns.push([])

      for (let i = 0; i < components.length; i++) {
        let index = i % columns.length
        if (i >= columns.length) index = (i + 1) % columns.length
        columns[index].push(components[i])
      }
      return columns
    })

    return {
      isStudent,
      breakpoint,
      placements,
      cols
    }
  }
}
</script>
